import { InfoWindowF, OverlayView } from '@react-google-maps/api';
import * as React from 'react';
import { markerStatusMap, markerZIndexMap } from './status-marker-map';

const Markers = ({marker, ids, index, focusedIndex, handleClick}) => {
	const { icon, label } = markerStatusMap(marker.wanAvailabilityStatus);
	const [selectedMarker, setSelectedMarker] = React.useState(false);	
	const handleMouseOver = React.useCallback(() => {
    setSelectedMarker(true);
  }, []);

  const handleMouseOut = React.useCallback(() => {
    setSelectedMarker(false);
  }, []);

	return (
    marker.wanAvailabilityStatus &&
    marker.location &&
    marker.fullAddress && (
      <OverlayView
        key={ids}
        position={{
          lat: +marker.location.lat,
          lng: +marker.location.lon,
        }}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
				zIndex={markerZIndexMap(marker.wanAvailabilityStatus)}
      >
        <div
          role="button"
          aria-label={`Site at ${marker.fullAddress}, status: ${label}`}
          tabIndex={0}
          onClick={() => handleClick(marker?.id)}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
          style={{
            width: 24,
            height: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            outline: focusedIndex === index ? '2px solid #0064d2' : 'none',
            cursor: 'pointer',
						borderRadius: '50%',
          }}
        >
          {icon ? (
            <img
              src={icon}
              alt={`${label} status icon`}
              width={16}
              height={16}
              style={{pointerEvents: 'none'}}
            />
          ) : (
            <span
              style={{
                width: 16,
                height: 16,
                backgroundColor: 'gray',
                borderRadius: '50%',
              }}
            />
          )}
          {(selectedMarker || (focusedIndex === index)) ? (
          <InfoWindowF
      			position={{
      				lat: +marker.location.lat,
      				lng: +marker.location.lon
      			}}
            onCloseClick={() => setSelectedMarker(false)}
						options={{
							disableAutoPan: true
						}}
          >
            <>
            <div>{marker.fullAddress}</div>
            <br/>
            <br/>
            <p><b>Status: </b>{marker.wanAvailabilityStatus}</p>
            </>
          </InfoWindowF>
        ) : null}
        </div>
      </OverlayView>
    )
  )
}

export default Markers;